import { render, staticRenderFns } from "./37.vue?vue&type=template&id=87597af0&scoped=true&"
var script = {}
import style0 from "./37.vue?vue&type=style&index=0&id=87597af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87597af0",
  null
  
)

export default component.exports